import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import PropTypes from 'prop-types';
import CloseButton from '../../common/CloseButton/CloseButton';
import '../../common/CommonText.css'
import './NotificationMainPopup.css';
import { baseurl } from "../../../api";

// const NotificationPopup = ({ isOpen, onClose }) => {
//     const popupRef = useRef(null);
//     const navigate = useNavigate();
    

//     const handleLogout = () => {
//         // Clear tokens from localStorage
//         localStorage.removeItem('accessToken');
//         localStorage.removeItem('refreshToken');
//         localStorage.removeItem('bearer');
//         onClose();
//         navigate('/login');
//     };

//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (popupRef.current && !popupRef.current.contains(event.target)) {
//                 onClose(); 
//             }
//         };
//         document.addEventListener("mousedown", handleClickOutside);

//         return () => {
//             document.removeEventListener("mousedown", handleClickOutside);
//         };
//     }, [onClose]);

//     if (!isOpen) return null;
//     const handlePersonalDetailClick = () => {
//         navigate(`/personal-profile/`); 
//       };
// return (
//     <div className="notifications-popup-overlay" >
//         <div className="notifications-popup-container " ref={popupRef}>
//             <div className='notifications-popup'>
//                 <div className="blue-header">
//                     <div className="blue-header-left">
//                         <span className="white fts-20 common-text ftw-5">Notifications</span>
//                         <select className="black common-text fts-13">
//                             <option className="black common-text fts-13">All</option>
//                             <option className="black common-text fts-13">second</option>
//                         </select>
//                     </div>
//                     <div className="cr-pointer close-notification-icon"  onClick={onClose}>
//                         <svg className="close-notification" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
//                             <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="white"/>
//                         </svg>
//                     </div>
//                 </div>
//                 <div className="notification-tiles-container bg-lt-green">
//                     <div className="notification-tile-left">
//                         <svg className="notification-popup-icon" width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
//                             <path d="M3.75 0C2.75544 0 1.80161 0.395088 1.09835 1.09835C0.395088 1.80161 0 2.75544 0 3.75V4.5H23.996V3.75C23.996 2.75544 23.6009 1.80161 22.8977 1.09835C22.1944 0.395088 21.2406 0 20.246 0H3.75ZM0 14.25V6H23.996V14.25C23.996 15.2446 23.6009 16.1984 22.8977 16.9017C22.1944 17.6049 21.2406 18 20.246 18H3.751C2.75644 18 1.80261 17.6049 1.09935 16.9017C0.396088 16.1984 0.00100017 15.2446 0.00100017 14.25M16.246 11.5C16.0471 11.5 15.8563 11.579 15.7157 11.7197C15.575 11.8603 15.496 12.0511 15.496 12.25C15.496 12.4489 15.575 12.6397 15.7157 12.7803C15.8563 12.921 16.0471 13 16.246 13H19.746C19.9449 13 20.1357 12.921 20.2763 12.7803C20.417 12.6397 20.496 12.4489 20.496 12.25C20.496 12.0511 20.417 11.8603 20.2763 11.7197C20.1357 11.579 19.9449 11.5 19.746 11.5H16.246Z" fill="#148F00"/>
//                         </svg>
//                         <div>
//                             <span className="d-block lt-gray common-text fts-13">New Payment Received From ?</span>
//                             <span className="lt-gray common-text fts-13">Customer name</span>
//                         </div>
//                     </div>
//                     <span className="black common-text fts-13">5.30 PM</span>
//                 </div>
//                 <div className="notification-tiles-container bg-lt-orange">
//                     <div className="notification-tile-left">
//                         <svg className="notification-popup-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                             <path fill-rule="evenodd" clip-rule="evenodd" d="M13.7143 5.14286C13.7143 6.50683 13.1725 7.81493 12.208 8.77941C11.2435 9.74388 9.9354 10.2857 8.57143 10.2857C7.20746 10.2857 5.89935 9.74388 4.93488 8.77941C3.97041 7.81493 3.42857 6.50683 3.42857 5.14286C3.42857 3.77889 3.97041 2.47078 4.93488 1.50631C5.89935 0.541835 7.20746 0 8.57143 0C9.9354 0 11.2435 0.541835 12.208 1.50631C13.1725 2.47078 13.7143 3.77889 13.7143 5.14286ZM18.4286 12.8571C18.7696 12.8571 19.0966 12.9926 19.3377 13.2337C19.5788 13.4748 19.7143 13.8019 19.7143 14.1429V17.1429H22.7143C23.0553 17.1429 23.3823 17.2783 23.6234 17.5194C23.8645 17.7606 24 18.0876 24 18.4286C24 18.7696 23.8645 19.0966 23.6234 19.3377C23.3823 19.5788 23.0553 19.7143 22.7143 19.7143H19.7143V22.7143C19.7143 23.0553 19.5788 23.3823 19.3377 23.6234C19.0966 23.8645 18.7696 24 18.4286 24C18.0876 24 17.7606 23.8645 17.5194 23.6234C17.2783 23.3823 17.1429 23.0553 17.1429 22.7143V19.7143H14.1429C13.8019 19.7143 13.4748 19.5788 13.2337 19.3377C12.9926 19.0966 12.8571 18.7696 12.8571 18.4286C12.8571 18.0876 12.9926 17.7606 13.2337 17.5194C13.4748 17.2783 13.8019 17.1429 14.1429 17.1429H17.1429V14.1429C17.1429 13.8019 17.2783 13.4748 17.5194 13.2337C17.7606 12.9926 18.0876 12.8571 18.4286 12.8571ZM8.57143 12C11.1309 12 13.4297 13.1229 15 14.9023V15H14.1429C13.3825 14.9993 12.6435 15.2514 12.0421 15.7167C11.4406 16.1819 11.0109 16.8338 10.8205 17.57C10.6301 18.3061 10.6898 19.0846 10.9902 19.7831C11.2906 20.4816 11.8147 21.0605 12.48 21.4286H0.857143C0.629814 21.4286 0.411797 21.3383 0.251051 21.1775C0.0903059 21.0168 0 20.7988 0 20.5714C0 18.2981 0.903059 16.118 2.51051 14.5105C4.11797 12.9031 6.29814 12 8.57143 12Z" fill="#DFA226"/>
//                         </svg>
//                         <div className="sample">
//                             <span className="lt-gray common-text fts-13">New Customer</span>
//                         </div>
//                     </div>
//                     <span className="black common-text fts-13">16-08-2024</span>
//                 </div>
//             </div>
//         </div>
//     </div>
// );
// };

// NotificationPopup.propTypes = {
// isOpen: PropTypes.bool.isRequired,
// onClose: PropTypes.func.isRequired,
// };

// export default NotificationPopup; 



// const NotificationPopup = ({ isOpen, onClose }) => {
//     const popupRef = useRef(null);
//     const navigate = useNavigate();
//     const [notifications, setNotifications] = useState([]);
//     const [filter, setFilter] = useState("All");
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);

//     const fetchNotifications = async () => {
//         setLoading(true);
//         setError(null);
//         try {
//             const accessToken = localStorage.getItem("accessToken");
//             if (!accessToken) {
//                 throw new Error("No access token found");
//             }

//             const response = await axios.get(`${baseurl}SuperAdminNotifications/notifications/`, {
//                 headers: {
//                     Authorization: `Bearer ${accessToken}`,
//                 },
//             });

//             const notificationsData = response.data || [];
//             setNotifications(notificationsData);
//         } catch (error) {
//             console.error("Error fetching notifications:", error);
//             setError("Failed to fetch notifications. Please try again.");
            
//             if (error.response && error.response.status === 401) {
//                 handleLogout();
//             }
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleLogout = () => {
//         localStorage.removeItem("accessToken");
//         localStorage.removeItem("refreshToken");
//         localStorage.removeItem("bearer");
//         onClose();
//         navigate("/login");
//     };

//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (popupRef.current && !popupRef.current.contains(event.target)) {
//                 onClose();
//             }
//         };
//         document.addEventListener("mousedown", handleClickOutside);

//         return () => {
//             document.removeEventListener("mousedown", handleClickOutside);
//         };
//     }, [onClose]);

//     useEffect(() => {
//         if (isOpen) {
//             fetchNotifications();
//         }
//     }, [isOpen]);

//     const filteredNotifications =
//         filter === "All"
//             ? notifications
//             : notifications.filter((notification) =>
//                   notification.message.toLowerCase().includes(filter.toLowerCase())
//               );

//     if (!isOpen) return null;

//     return (
//         <div className="notifications-popup-overlay">
//             <div className="notifications-popup-container" ref={popupRef}>
//                 <div className="notifications-popup">
//                     <div className="blue-header">
//                         <div className="blue-header-left">
//                             <span className="white fts-20 common-text ftw-5">Notifications</span>
//                             <select
//                                 className="black common-text fts-13"
//                                 value={filter}
//                                 onChange={(e) => setFilter(e.target.value)}
//                             >
//                                 <option value="All">All</option>
//                                 <option value="Payment">Payment</option>
//                                 <option value="Customer">Customer</option>
//                             </select>
//                         </div>
//                         <div
//                             className="cr-pointer close-notification-icon"
//                             onClick={onClose}
//                         >
//                             <svg
//                                 className="close-notification"
//                                 width="14"
//                                 height="14"
//                                 viewBox="0 0 14 14"
//                                 fill="none"
//                                 xmlns="http://www.w3.org/2000/svg"
//                             >
//                                 <path
//                                     d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
//                                     fill="white"
//                                 />
//                             </svg>
//                         </div>
//                     </div>
//                     <div className="notifications-content">
//                         {loading ? (
//                             <div className="loading-notifications">
//                                 <span className="lt-gray common-text fts-13">
//                                     Loading notifications...
//                                 </span>
//                             </div>
//                         ) : error ? (
//                             <div className="error-notifications">
//                                 <span className="lt-gray common-text fts-13">
//                                     {error}
//                                 </span>
//                             </div>
//                         ) : filteredNotifications.length > 0 ? (
//                             filteredNotifications.map((notification) => (
//                                 <div key={notification.id} className="notification-tiles-container bg-lt-green">
//                                     <div className="notification-tile-left">
//                                         <svg className="notification-popup-icon" width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                             <path d="M3.75 0C2.75544 0 1.80161 0.395088 1.09835 1.09835C0.395088 1.80161 0 2.75544 0 3.75V4.5H23.996V3.75C23.996 2.75544 23.6009 1.80161 22.8977 1.09835C22.1944 0.395088 21.2406 0 20.246 0H3.75ZM0 14.25V6H23.996V14.25C23.996 15.2446 23.6009 16.1984 22.8977 16.9017C22.1944 17.6049 21.2406 18 20.246 18H3.751C2.75644 18 1.80261 17.6049 1.09935 16.9017C0.396088 16.1984 0.00100017 15.2446 0.00100017 14.25M16.246 11.5C16.0471 11.5 15.8563 11.579 15.7157 11.7197C15.575 11.8603 15.496 12.0511 15.496 12.25C15.496 12.4489 15.575 12.6397 15.7157 12.7803C15.8563 12.921 16.0471 13 16.246 13H19.746C19.9449 13 20.1357 12.921 20.2763 12.7803C20.417 12.6397 20.496 12.4489 20.496 12.25C20.496 12.0511 20.417 11.8603 20.2763 11.7197C20.1357 11.579 19.9449 11.5 19.746 11.5H16.246Z" fill="#148F00"/>
//                                         </svg>
//                                         <div>
//                                             <span className="d-block lt-gray common-text fts-13">
//                                                 {notification.message}
//                                             </span>
//                                             <span className="d-block lt-gray common-text fts-13">
//                                                 {notification.username}
//                                             </span>
//                                             <span className="lt-gray common-text fts-13">
//                                                 {new Date(
//                                                     notification.created_at
//                                                 ).toLocaleString()}
//                                             </span>
//                                         </div>
//                                     </div>
//                                 </div>
//                             ))
//                         ) : (
//                             <div className="no-notifications">
//                                 <span className="lt-gray common-text fts-13">
//                                     No notifications to display
//                                 </span>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// NotificationPopup.propTypes = {
//     isOpen: PropTypes.bool.isRequired,
//     onClose: PropTypes.func.isRequired,
// };

// export default NotificationPopup;

const NotificationPopup = ({ isOpen, onClose }) => {
    const popupRef = useRef(null);
    const navigate = useNavigate();
    const [notifications, setNotifications] = useState([]);
    const [filter, setFilter] = useState("All");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchNotifications = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await axios.get(`${baseurl}SuperAdminNotifications/notifications/`, {
            });

            const notificationsData = response.data || [];
            setNotifications(notificationsData);
        } catch (error) {
            console.error("Error fetching notifications:", error);
            setError("Failed to fetch notifications. Please try again.");
            
            if (error.response && error.response.status === 401) {
                handleLogout();
            }
        } finally {
            setLoading(false);
        }
    };

    const handleLogout = () => {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("bearer");
        onClose();
        navigate("/login");
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose]);

    useEffect(() => {
        if (isOpen) {
            fetchNotifications();
        }
    }, [isOpen]);

    const filteredNotifications =
        filter === "All"
            ? notifications
            : notifications.filter((notification) =>
                  notification.message.toLowerCase().includes(filter.toLowerCase())
              );

    if (!isOpen) return null;

    return (
        <div className="notifications-popup-overlay">
            <div className="notifications-popup-container" ref={popupRef}>
                <div className="notifications-popup">
                    <div className="blue-header">
                        <div className="blue-header-left">
                            <span className="white fts-20 common-text ftw-5">Notifications</span>
                            <select
                                className="black common-text fts-13"
                                value={filter}
                                onChange={(e) => setFilter(e.target.value)}
                            >
                                <option value="All">All</option>
                                <option value="Payment">Payment</option>
                                <option value="Customer">Customer</option>
                            </select>
                        </div>
                        <div
                            className="cr-pointer close-notification-icon"
                            onClick={onClose}
                        >
                            <svg
                                className="close-notification"
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                    </div>

                    <div className="notifications-content">
                        {loading ? (
                            <div className="loading-notifications">
                                <span className="lt-gray common-text fts-13">
                                    Loading notifications...
                                </span>
                            </div>
                        ) : error ? (
                            <div className="error-notifications">
                                <span className="lt-gray common-text fts-13">{error}</span>
                            </div>
                        ) : filteredNotifications.length > 0 ? (
                            filteredNotifications.map((notification) => (
 

<div
    key={notification.id}
    className={`notification-tiles-container ${
        notification.type === "payment" ? "bg-lt-green" : "bg-lt-orange"
    }`}
>
    <div className="notification-tile-left">
        <svg
            className="notification-popup-icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {notification.type === "payment" ? (
                // Payment SVG
                 <path d="M3.75 0C2.75544 0 1.80161 0.395088 1.09835 1.09835C0.395088 1.80161 0 2.75544 0 3.75V4.5H23.996V3.75C23.996 2.75544 23.6009 1.80161 22.8977 1.09835C22.1944 0.395088 21.2406 0 20.246 0H3.75ZM0 14.25V6H23.996V14.25C23.996 15.2446 23.6009 16.1984 22.8977 16.9017C22.1944 17.6049 21.2406 18 20.246 18H3.751C2.75644 18 1.80261 17.6049 1.09935 16.9017C0.396088 16.1984 0.00100017 15.2446 0.00100017 14.25M16.246 11.5C16.0471 11.5 15.8563 11.579 15.7157 11.7197C15.575 11.8603 15.496 12.0511 15.496 12.25C15.496 12.4489 15.575 12.6397 15.7157 12.7803C15.8563 12.921 16.0471 13 16.246 13H19.746C19.9449 13 20.1357 12.921 20.2763 12.7803C20.417 12.6397 20.496 12.4489 20.496 12.25C20.496 12.0511 20.417 11.8603 20.2763 11.7197C20.1357 11.579 19.9449 11.5 19.746 11.5H16.246Z" fill="#148F00"/>

            ) : notification.type === "customer" ? (
                // Customer SVG
                 <path fill-rule="evenodd" clip-rule="evenodd" d="M13.7143 5.14286C13.7143 6.50683 13.1725 7.81493 12.208 8.77941C11.2435 9.74388 9.9354 10.2857 8.57143 10.2857C7.20746 10.2857 5.89935 9.74388 4.93488 8.77941C3.97041 7.81493 3.42857 6.50683 3.42857 5.14286C3.42857 3.77889 3.97041 2.47078 4.93488 1.50631C5.89935 0.541835 7.20746 0 8.57143 0C9.9354 0 11.2435 0.541835 12.208 1.50631C13.1725 2.47078 13.7143 3.77889 13.7143 5.14286ZM18.4286 12.8571C18.7696 12.8571 19.0966 12.9926 19.3377 13.2337C19.5788 13.4748 19.7143 13.8019 19.7143 14.1429V17.1429H22.7143C23.0553 17.1429 23.3823 17.2783 23.6234 17.5194C23.8645 17.7606 24 18.0876 24 18.4286C24 18.7696 23.8645 19.0966 23.6234 19.3377C23.3823 19.5788 23.0553 19.7143 22.7143 19.7143H19.7143V22.7143C19.7143 23.0553 19.5788 23.3823 19.3377 23.6234C19.0966 23.8645 18.7696 24 18.4286 24C18.0876 24 17.7606 23.8645 17.5194 23.6234C17.2783 23.3823 17.1429 23.0553 17.1429 22.7143V19.7143H14.1429C13.8019 19.7143 13.4748 19.5788 13.2337 19.3377C12.9926 19.0966 12.8571 18.7696 12.8571 18.4286C12.8571 18.0876 12.9926 17.7606 13.2337 17.5194C13.4748 17.2783 13.8019 17.1429 14.1429 17.1429H17.1429V14.1429C17.1429 13.8019 17.2783 13.4748 17.5194 13.2337C17.7606 12.9926 18.0876 12.8571 18.4286 12.8571ZM8.57143 12C11.1309 12 13.4297 13.1229 15 14.9023V15H14.1429C13.3825 14.9993 12.6435 15.2514 12.0421 15.7167C11.4406 16.1819 11.0109 16.8338 10.8205 17.57C10.6301 18.3061 10.6898 19.0846 10.9902 19.7831C11.2906 20.4816 11.8147 21.0605 12.48 21.4286H0.857143C0.629814 21.4286 0.411797 21.3383 0.251051 21.1775C0.0903059 21.0168 0 20.7988 0 20.5714C0 18.2981 0.903059 16.118 2.51051 14.5105C4.11797 12.9031 6.29814 12 8.57143 12Z" fill="#DFA226"/>

            ) : (
                // Default SVG for other types
                <circle cx="12" cy="12" r="12" fill="#ccc" />
            )}
        </svg>
        <div>
            <span className="d-block lt-gray common-text fts-13">
                {notification.message}
            </span>
            <span className="d-block lt-gray common-text fts-13">
                {notification.username}
            </span>
        </div>
    </div>
    {/* <span className="black common-text fts-13">
        {new Date(`1970-01-01T${notification.time}Z`).toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        })}
    </span> */}
    <span className="black common-text fts-13">
    {(() => {
        const today = new Date();
        const notifDate = new Date(notification.created_at);
        const isToday =
            notifDate.getDate() === today.getDate() &&
            notifDate.getMonth() === today.getMonth() &&
            notifDate.getFullYear() === today.getFullYear();

        return isToday
            ? notifDate.toLocaleTimeString("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
              })
            // : notifDate.toLocaleDateString("en-GB"); // e.g., 16/08/2024
            : `${notifDate.getDate().toString().padStart(2, '0')}-${(notifDate.getMonth() + 1).toString().padStart(2, '0')}-${notifDate.getFullYear()}`

    })()}
</span>

</div>


                            ))
                        ) : (
                            <div className="no-notifications">
                                <span className="lt-gray common-text fts-13">
                                    No notifications to display
                                </span>
                            </div>
                        )}
                    </div>
                    
                </div>
            </div>
        </div>
    );
};

NotificationPopup.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default NotificationPopup;





